module.exports = __webpack_public_path__ + "static/media/menuSpecials.ece91467.png";